import { IDocument } from '../models';

export function fromJsonApi(data, included: any[]): IDocument {
  return {
    id: data.id,
    name: data.attributes.name,
    filePath: data.attributes.file_path,
    shortName: data.attributes.short_name,
    displayName: data.attributes.display_name,
  };
}
